import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  position: "relative",
}));

export const CountryItem = styled("div")(({ theme }) => ({
  ...theme.mixins.flexAlignCenter,
  ...theme.paddings(7, 10),
  gap: 5,
  cursor: "pointer",
  color: theme.palette.text.primary,
  fontSize: 14,

  "&:hover": {
    backgroundColor: theme.palette.background.light,
  },

  [theme.down("sm")]: {
    fontSize: 13,
    ...theme.paddings(6, 8),
  },
}));

export const CountryLabel = styled("span")(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: 13,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  flex: 1,

  [theme.down("sm")]: {
    fontSize: 12,
  },
}));
